import * as React from 'react';

export interface IFilterMenuOptionProps {
  title: string;
  onClick?(): void;
}

export default ({ title, onClick }: IFilterMenuOptionProps) => (
  <div className="filtermenu-option" onClick={() => onClick && onClick()}>
    {title}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/FilterMenu/FilterMenuOption.tsx